module.exports = __webpack_public_path__ + "static/img/s22.9349525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demoimages/s22.png
// module id = 6Ua9
// module chunks = 0